/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: '/',
    name: 'Home',
    slug: 'home',
    icon: 'HomeIcon',
    submenu: [
      {
        url: '/main',
        name: '메인',
        slug: 'Main',
        icon: 'FileIcon'
      },
      {
        url: '/content',
        name: '학습메뉴 테스트',
        slug: 'Content',
        icon: 'FileIcon'
      }
      // ,
      // {
      //   url: '/study/listening-sound/V010',
      //   //url: '/listening-sound',
      //   name: 'Listening Sound',
      //   slug: 'Listening Sound',
      //   icon: 'FileIcon'
      // },
      // {
      //   url: '/study/listening-with-pictures/V080',
      //   //url: '/listening-with-pictures',
      //   name: 'Listening With Pictures',
      //   slug: 'Listening With Pictures',
      //   icon: 'FileIcon'
      // },
      // {
      //   url: '/listening-with-subtitles',
      //   name: 'Listening With Subtitles',
      //   slug: 'Listening With Subtitles',
      //   icon: 'FileIcon'
      // },
      // {
      //   url: '/word-dictation1',
      //   name: 'Word Dictation1',
      //   slug: 'Word Dictation1',
      //   icon: 'FileIcon'
      // },
      // {
      //   url: '/word-dictation2',
      //   name: 'Word Dictation2',
      //   slug: 'Word Dictation2',
      //   icon: 'FileIcon'
      // },
      // {
      //   url: '/word-dictation3',
      //   name: 'Word Dictation3',
      //   slug: 'Word Dictation3',
      //   icon: 'FileIcon'
      // },
      // {
      //   url: '/writing-words',
      //   name: 'Writing Words',
      //   slug: 'Writing Words',
      //   icon: 'FileIcon'
      // },
      // {
      //   url: '/listening-words',
      //   name: 'Listening Words',
      //   slug: 'Listening Words',
      //   icon: 'FileIcon'
      // },
      // {
      //   url: '/listen-and-fill-in',
      //   name: 'Listen And Fill In',
      //   slug: 'Listen And Fill In',
      //   icon: 'FileIcon'
      // },
      // {
      //   url: '/writing-blank-type1',
      //   name: 'Writing Blank Type1',
      //   slug: 'Writing Blank Type1',
      //   icon: 'FileIcon'
      // },
      // {
      //   url: '/checking-words',
      //   name: 'Checking Words',
      //   slug: 'Checking Words',
      //   icon: 'FileIcon'
      // },
      // {
      //   url: '/sentence-dictation-type1',
      //   name: 'Sentence Dictation Type1',
      //   slug: 'Sentence Dictation Type1',
      //   icon: 'FileIcon'
      // },
      // {
      //   url: '/sentence-dictation-type2',
      //   name: 'Sentence Dictation Type2',
      //   slug: 'Sentence Dictation Type2',
      //   icon: 'FileIcon'
      // },
      // {
      //   url: '/speaking-words',
      //   name: 'Speaking Words',
      //   slug: 'Speaking Words',
      //   icon: 'FileIcon'
      // },
      // {
      //   url: '/shadow-reading',
      //   name: 'Shadow Reading',
      //   slug: 'Shadow Reading',
      //   icon: 'FileIcon'
      // },
      // {
      //   url: '/reading-and-translating',
      //   name: 'Reading And Translating',
      //   slug: 'Reading And Translating',
      //   icon: 'FileIcon'
      // },
      // {
      //   url: '/sentence-speaking',
      //   name: 'Sentence Speaking',
      //   slug: 'Sentence Speaking',
      //   icon: 'FileIcon'
      // },
      // {
      //   url: '/speak-straight',
      //   name: 'Speak Straight',
      //   slug: 'Speak Straight',
      //   icon: 'FileIcon'
      // },
      // {
      //   url: '/matching-sentences',
      //   name: 'Matching Sentences',
      //   slug: 'Matching Sentences',
      //   icon: 'FileIcon'
      // },
      // {
      //   url: '/role-play',
      //   name: 'Role Play',
      //   slug: 'Role Play',
      //   icon: 'FileIcon'
      // },
    ]
  }
]
